<template>
  <div class='no-photo-placeholder'>
    <span class="material-icons">
      no_photography
    </span>
  </div>
</template>

<script>
export default {
  name: 'NoPhotoPlaceholder',
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.no-photo-placeholder {
  background-color: var(--bg-disabled);
  max-width: rem(95);
  min-width: rem(95);
  min-height: rem(75);
  max-height: rem(75);
  position: relative;
  .material-icons {
    color: var(--text-secondary);
    position: absolute;
    font-size: $font-size-2xl;
    left: rem(37);
    top: rem(27);
  }
}
</style>
